import { getCookie, setCookie, updateCookie, text_truncate, getBrowserType } from '../core/utils.js';
// import { setCampaignInfo } from '../components/campaign-info.js';

var code = '',
    ccode = '',
    leads_referrer = document.referrer;

export function waba() {

  var curr_lang = document.documentElement.getAttribute('lang') ? document.documentElement.getAttribute('lang') : 'id';

  var firstlanding = '';

  if(getCookie('user_journey')) {
    var journey_ = getCookie('user_journey');
    journey_ = journey_.split('|');
    if(journey_.length > 1) {
      firstlanding = journey_[0].replace('J','');
    }
  }

  var waba_buttons = document.querySelectorAll('.cta-waba');
  if(waba_buttons.length > 0) {
    waba_buttons.forEach(button => {

        button.classList.add('show');

        button.addEventListener('click', function(e) {
          e.preventDefault();
          // iOS Safari: window.open HARUS dipanggil langsung di sini (dalam konteks user gesture),
          // sebelum processing apapun — jika dipanggil terlambat, Safari akan blokirnya sebagai popup.
          var browserType = getBrowserType();
          var safariNewTab = null;
          if(browserType === 'Apple Safari (iOS)') {
            safariNewTab = window.open('about:blank', '_blank');
          }
          document.querySelectorAll('.has-loading').forEach(function(el) {
              el.style.display = 'flex';
          });

          var url_string = window.location.href; //window.location.href
          var url = new URL(url_string);
          var click_date = new Date();
          var click_DD = (click_date.getDate() < 10 ? '0' : '') + click_date.getDate();
          var click_MM = ((click_date.getMonth() + 1) < 10 ? '0' : '') + parseInt(click_date.getMonth() + 1);
          var click_YY = click_date.getFullYear().toString().slice(2);
          var click_hh = (click_date.getHours() < 10 ? '0' : '') + click_date.getHours();
          var click_mm = (click_date.getMinutes() < 10 ? '0' : '') + click_date.getMinutes();
          var click_ss = click_date.getSeconds();
          var click_ms = click_date.getMilliseconds();
          var click_sh = click_DD + click_MM + click_YY + click_hh + click_mm + click_ss + click_ms;
          var gclid = url.searchParams.get("gclid") || getCookie('gclid') || '';
          var msclkid = url.searchParams.get("msclkid") || getCookie('msclkid') || '';
          var umedium = url.searchParams.get("utm_medium") || getCookie('utm_medium') || '';
          var ucampaign = url.searchParams.get("utm_campaign") || getCookie('utm_campaign') || '';
          var usource = url.searchParams.get("utm_source") || getCookie('utm_source') || '';
          var utm_term = url.searchParams.get("utm_term") || getCookie('utm_term') || '';
          var matchtype = url.searchParams.get("matchtype") || getCookie('matchtype') || '';
          var query_keyword = url.searchParams.get("query") || getCookie('query_keyword') || 'null';
          var devicetype = 'desktop';
          var gclidmsclkid = '';
          var banner_journey = getCookie('banner_journey') || '';
          var cta_journey = getCookie('cta_journey') || '';
          var cta_last_click = getCookie('cta_last_click') || '';
          var medium_code = getCookie('waba_code') || '';
          var campaign_code = getCookie('medium_code') || '';

          if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent) ||
            /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0, 4))) {
            devicetype = 'mobile';
          } else {
            devicetype = 'desktop';
          }

          // if(this.classList.contains('top-banner-sticky') || this.classList.contains('top-banner-bot')) {
          //   var bc_cookie = getCookie('banner_click') ? getCookie('banner_click') : '';

          //   var today = new Date(),
          //       year = today.getFullYear().toString().slice(-2),
          //       month = (today.getMonth() + 1).toString();
          //   if (month.length === 1) {
          //       month = "0" + month;
          //   }
          //   var formattedDate = year + month;

          //   if(bc_cookie != '') {
          //     if (f_banner_id) {
          //       f_banner_id.setAttribute('value',bc_cookie);
          //     }
          //   } else {
          //     if(f_banner_id) {
          //       f_banner_id.setAttribute('value',formattedDate);
          //     }
          //   }
          // }

          var $url = this.getAttribute('href');
          // if($url.includes('{{code}} -')) {
          //   $url = $url.replace('{{code}}','[Req.J' + click_sh + ']');
          // } else if($url.includes('{{code}}%20-%20')) { 
          //   $url = $url.replace('{{code}}','[Req.J' + click_sh + ']');
          // } else {
          //   $url = $url.replace('{{code}}','[Req.J' + click_sh + '] - ');
          // }

          if ($url) {
            if (utm_term != "") {
                const keywordRegex =
                    /(aplikasi|app|program|software|system|sistem|platform|paling\s|terbaik|terbagus|\bthe\b|best|berbasis web)/i;
                const keywordRegexNew = /(invoice online|laporan keuangan perusahaan|laporan keuangan|buat invoice online|cara membuat laporan keuangan|buat invoice|membuat invoice online|invoice template|invoice generator)/i;
                if (keywordRegex.test(utm_term) || keywordRegexNew.test(utm_term)) {
                    var kw = "";
                    const kw_inventory =
                            /(inventor|stok|stock|gudang|mrp|warehouse|wms|scm|sedia|inventar|barang|supply chain)/i,
                        kw_invoice =
                            /(invoic|faktur|tagih|kwitansi|tempo|bon|nota)/i,
                        kw_invoice_exclude = /manu/i,
                        hw_manufacture =
                            /(manufa|pabrik|produksi)/i,
                        kw_accounting =
                            /(akutans|akuntans|accounti|laporan|report|keuangan|buku|bookkeeping|buku|ledger|catat)/i,
                        kw_erp = /(erp)/i

                    if (kw_inventory.test(utm_term)) {
                        kw = "'Inventory' ";
                    }

                    if (kw_invoice.test(utm_term)) {
                        if (!kw_invoice_exclude.test(utm_term)) {
                            kw = "'Invoice' ";
                        }
                    }

                    if (hw_manufacture.test(utm_term)) {
                        kw = "'Manufacture' ";
                    }

                    if (kw_accounting.test(utm_term)) {
                        kw = "'Accounting' ";
                    }

                    if (kw_erp.test(utm_term)) {
                        kw = "'ERP' ";
                    }

                    var $url_ = $url.split("{{code}}");
                    if (
                        $url.includes(
                            "tertarik dengan fitur Mekari Jurnal"
                        )
                    ) {
                        $url =
                            $url_[0] +
                            "[Req.J" +
                            click_sh +
                            "] - Halo, Saya tertarik dengan fitur " +
                            kw +
                            "Mekari Jurnal";
                    } else if (
                        $url.includes("ask more about Mekari Jurnal")
                    ) {
                        $url =
                            $url_[0] +
                            "[Req.J" +
                            click_sh +
                            "] - Hello, I want to ask more about " +
                            kw +
                            "Mekari Jurnal";
                    } else if (
                        $url.includes("interested with Mekari Jurnal")
                    ) {
                        $url =
                            $url_[0] +
                            "[Req.J" +
                            click_sh +
                            "] - Hello, I'm interested with " +
                            kw +
                            " Mekari Jurnal";
                    } else {
                        if ($url.includes("{{code}} -")) {
                            $url = $url.replace(
                                "{{code}}",
                                "[Req.J" + click_sh + "]"
                            );
                        } else if ($url.includes("{{code}}%20-%20")) {
                            $url = $url.replace(
                                "{{code}}",
                                "[Req.J" + click_sh + "]"
                            );
                        } else {
                            $url = $url.replace(
                                "{{code}}",
                                "[Req.J" + click_sh + "] - "
                            );
                        }
                    }
                } else {
                    if ($url.includes("{{code}} -")) {
                        $url = $url.replace(
                            "{{code}}",
                            "[Req.J" + click_sh + "]"
                        );
                    } else if ($url.includes("{{code}}%20-%20")) {
                        $url = $url.replace(
                            "{{code}}",
                            "[Req.J" + click_sh + "]"
                        );
                    } else {
                        $url = $url.replace(
                            "{{code}}",
                            "[Req.J" + click_sh + "] - "
                        );
                    }
                }
            } else {
                if ($url.includes("{{code}} -")) {
                    $url = $url.replace(
                        "{{code}}",
                        "[Req.J" + click_sh + "]"
                    );
                } else if ($url.includes("{{code}}%20-%20")) {
                    $url = $url.replace(
                        "{{code}}",
                        "[Req.J" + click_sh + "]"
                    );
                } else {
                    $url = $url.replace(
                        "{{code}}",
                        "[Req.J" + click_sh + "] - "
                    );
                }
            }
          }

          if($url.includes('{{suff}}')) {
            $url = $url.replace('{{suff}}', '');
          } else if($url.includes('{{suf}}')) { 
            $url = $url.replace('{{suf}}', '');
          } else if($url.includes('{{suff1}}')) { 
            $url = $url.replace('{{suff1}}', '');
          } else if($url.includes('{{suff2}}')) { 
            $url = $url.replace('{{suff2}}', '');
          } else if($url.includes('{{suff3}}')) { 
            $url = $url.replace('{{suff3}}', '');
          }

          $url += "&app_absent=0";

          var waba_redirect = document.querySelector('#waba_redirect');
          if(waba_redirect) {
            waba_redirect.value = $url;
          }

          var form_waba = document.querySelector('#form_shortener_gclid');
          if(form_waba) {

            var f_gclid_short = document.querySelector('#f_gclid_short'),
                f_gclid = document.querySelector('#f_gclid'),
                f_device = document.querySelector('#f_device'),
                f_utmsource = document.querySelector('#f_utmsource'),
                f_utmmedium = document.querySelector('#f_utmmedium'),
                f_utmcampaign = document.querySelector('#f_utmcampaign'),
                f_utmterm = document.querySelector('#f_utmterm'),
                f_banner_id = document.querySelector('#f_banner_id'),
                f_gclid_journey = document.querySelector('#f_gclid_journey'),
                f_matchtype = document.querySelector('#f_matchtype'),
                f_journey = document.querySelector('#f_journey'),
                f_gaid = document.querySelector('#f_gaid'),
                f_waba_medium = document.querySelector('#f_waba_medium'),
                f_browser = document.querySelector('#f_browser'),
                f_referrer = document.querySelector('#f_referrer'),
                f_query_keyword = document.querySelector('#f_query_keyword'),
                f_visitor_id = document.querySelector('#f_visitor_id');

            var label = "";

            // Get CTA ID and Label
            if(this.classList.contains('ic-wa')) {
              label = 'ID: '+ this.id +', Label: Sticky WABA';
            } else if(this.classList.contains('top-banner-sticky') || this.classList.contains('top-banner-bot')) {
               label = 'ID: '+ this.id +', Label: Sticky Banner';
            } else if(this.id != '') {
              label = 'ID: ' + this.id + ', Label: '+ this.innerText;
            } else {
              label = 'ID: , Label: '+ this.innerText;
            }

            var f_label = document.querySelector('#f_label');

            var cta_journey_$url = '';
            if(cta_journey != '') {
              if(cta_last_click != '') {
                if(cta_last_click != button.id) {
                  cta_journey_$url = cta_journey + '|' + label;
                } else {
                  cta_journey_$url = cta_journey;
                }
              } else {
                cta_journey_$url = label;
              }
            } else {
                cta_journey_$url = label;
            }
            
            if (f_label) f_label.value = cta_journey_$url;
        
            if(getCookie('cta_journey')) {
              updateCookie('cta_journey', cta_journey_$url);
            } else {
              setCookie('cta_journey', cta_journey_$url, 31);
            }
            
            if(getCookie('cta_last_click')) {
              updateCookie('cta_last_click', button.id);
            } else {
              setCookie('cta_last_click', button.id, 31);
            }
            
            if(f_gclid_short) { 
              f_gclid_short.setAttribute('value',click_sh);
            }
            
            if(f_gclid) { 
              gclidmsclkid = text_truncate(gclid+'|'+msclkid,250,'');
              f_gclid.setAttribute('value',gclidmsclkid) 
            }

            if(f_gclid_journey) { 
              f_gclid_journey.setAttribute('value',(getCookie('gclid_journey') ? getCookie('gclid_journey') : ''));
            }

            if(f_utmsource) { 
              if(usource === 'chatgpt.com') {
                f_utmsource.setAttribute('value','website'); 
              } else {
                f_utmsource.setAttribute('value',usource);
              }
            }

            if(f_utmmedium) { 
              f_utmmedium.setAttribute('value',umedium) 
            }

            if(f_utmcampaign) { 
              f_utmcampaign.setAttribute('value',ucampaign) 
            }

            if(f_utmterm) { 
              f_utmterm.setAttribute('value',utm_term) 
            }

            if(f_matchtype) { 
              f_matchtype.setAttribute('value',matchtype) 
            }

            if(f_device) {
              if (devicetype == 'desktop') {
                f_device.setAttribute('value','Desktop');
              } else {
                f_device.setAttribute('value','Mobile');
              }
            }

            if(f_journey) { 
              var limit_journey = text_truncate(getCookie('user_journey'), 250, '');
              f_journey.setAttribute('value',limit_journey);
            }

            if(f_gaid) { 
              if(getCookie('gaid')) {
                f_gaid.setAttribute('value',getCookie('gaid')); 
              } else {
                if(getCookie('_ga')) {
                  f_gaid.setAttribute('value',getCookie('_ga').slice(6)); 
                }
              }
            }

            if(f_waba_medium) {
              if(medium_code) {
                f_waba_medium.setAttribute('value',medium_code);
              } 
              
            }

            if(f_browser) {
              f_browser.value = browserType;
            }

            if (f_banner_id) { f_banner_id.setAttribute('value', banner_journey || ''); }

            if(getCookie('lead_referrer')) {
              if(f_referrer) {
                f_referrer.value = getCookie('lead_referrer');
              }
            }

            if(f_query_keyword) {
              f_query_keyword.value = query_keyword;
            }

            if(f_visitor_id) {
              f_visitor_id.value = getCookie('visitor_id') || '';
            }

            document.querySelectorAll('.has-loading').forEach(function(el) {
                el.style.display = 'none';
            });

            if(browserType === 'Apple Safari (iOS)') {
              // safariNewTab sudah dibuka di awal click handler (user gesture context)
              if (safariNewTab) {
                safariNewTab.location.href = $url;
              }
            } else {
              window.open($url, '_blank').focus();
            }
            

            const scriptURL = 'https://script.google.com/macros/s/AKfycbzpfADklTe8mxAB0mJHYes9Srkz4mHpWpl_JHJPZ6OV6_e63YEwqK2apDlndXFMZPmp/exec';
            const form = document.forms['form-shortener-gclid'];
            
            // keepalive: true memastikan request tetap dikirim meski tab pindah ke background (iOS Safari)
            fetch(scriptURL, { method: 'POST', body: new FormData(form), keepalive: true })
              .then(response => { 
                if(response.status == 200) {
                  document.querySelectorAll('.has-loading').forEach(function(el) {
                      el.style.display = 'none';
                  });
                } else {
                  console.error('Response code : ', response.status);
                }
                })
              .catch(error => {
                console.error('Error!', error.message);
              });
          }
        });
    });
  }

  // untuk memanggil function generate campaign info setelah waba code diperoleh

  // if(is_sr == "false") {
  //   setCampaignInfo();
  // }
}